export const initialGestiuniState = {
  gestiuni: [],
  gestiuniById: {},
  loading: false,
};

export interface IGestiuniState {
  gestiuni: any[],
  gestiuniById: {},
  loading: boolean,
}


